import { Context } from '@nuxt/types'
import { logger } from '@ustra/core'

export default async (ctx: Context, _cb) => {
  _cb()
}
